import React, {useEffect} from "react";

import {DateFormatter} from "../../../../services/date";
import {useQuotes} from "../../QuotesContext";
import BotIcon from "../../BotIcon";

import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {styled} from "@mui/material";
import ListItem from "@mui/material/ListItem";
import Skeleton from "@mui/material/Skeleton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditCalendarIcon from '@mui/icons-material/EditCalendar';

export const quoteItemHeight = 76;

const FixedHeightItemList = styled(ListItem)({
    height: `${quoteItemHeight}px`,
    maxHeight: `${quoteItemHeight}px`,
    width: '100%', // this is needed for the typography noWrap option to work
})


export const QuoteItem = ({quote}) => {
    const {handleQuoteSelection} = useQuotes();
    const price = parseFloat(quote.priceCentFrom !== 0 ? quote.priceCentFrom / 100 : quote.priceCentFrom).toFixed(2)

    return <FixedHeightItemList disablePadding divider>
        <ListItemButton onClick={() => handleQuoteSelection(quote.id)} sx={{width: "100%", py:0, px: 2}}>
            <ListItemText disableTypography
                          primary={
                              <Stack direction="row" spacing={1}>
                                  <Typography noWrap>{quote.surname} {quote.name}</Typography>
                                  {quote.createdByAutoReply === true && <BotIcon color="secondary" fontSize="small"/>}
                                  {quote.datesChanged === true && <EditCalendarIcon color="warning" fontSize="small"/>}
                                  {quote.confirmed === true && <CheckCircleIcon color="success" fontSize="small"/>}
                              </Stack>
                          }
                          secondary={<>
                              <Typography fontSize="small" noWrap>
                                  {DateFormatter.shortString(quote.arrival)} - {DateFormatter.shortString(quote.departure)}
                              </Typography>
                              <Typography color="text.primary" fontSize="small" noWrap>
                                  Creato il {DateFormatter.shortString(quote.createdAt)} {DateFormatter.timeString(quote.createdAt)}
                              </Typography>
                              </>}
            />
            {
                <Stack>
                    <Typography fontSize="small">
                        {`#${quote.codeNumber}`}
                    </Typography>
                    <Typography color="primary" fontWeight="medium"
                                textAlign="right">
                        {`${price} €`}
                    </Typography>
                </Stack>
            }
        </ListItemButton>
    </FixedHeightItemList>
}

export const QuotesBlock = ({index, style}) => {
    const {quotesPagination} = useQuotes();
    const {pages, loadPage, isPageLoading} = quotesPagination;
    const pageNumber = quotesPagination.initialPageNumber + index;

    useEffect(
        () => {
            loadPage(pageNumber);
        },
        [] // eslint-disable-line react-hooks/exhaustive-deps
    )

    const quotes = pages[pageNumber]?.items;

    return <div style={style}>
        {isPageLoading(pageNumber) ? <QuotesBlockSkeleton/> : quotes.map(q => <QuoteItem quote={q} key={q.id}/>)}
    </div>
}

export const QuotesBlockSkeleton = () => {
    const {quotesPagination} = useQuotes();
    const {pageSize} = quotesPagination;
    const skeletons = [...Array(pageSize)];

    return skeletons.map((_, i) => <FixedHeightItemList key={i} divider>
        <Skeleton height={`${quoteItemHeight}px`} width="100%"/>
    </FixedHeightItemList>);
}